module.exports = __webpack_public_path__ + "assets/0bb46a2109b647eccb5ddf793c1ef84e.png";